import { spSite_Affirmation_By_Site_ID } from '@models/StoredProcs/spSite_Affirmation_By_Site_ID';
import { spSite_CC_Info_List } from '@models/StoredProcs/spSite_CC_Info_List';
import { spSite_Client_By_Domain } from '@models/StoredProcs/spSite_Client_By_Domain';

export class spSite_Client_By_DomainX extends spSite_Client_By_Domain {
    public constructor(init?: Partial<spSite_Client_By_DomainX>) {
        super();
        Object.assign(this, init);
    }

    Site_CC_Info_List: spSite_CC_Info_List[] = [];
    Site_Affirmation_List: spSite_Affirmation_By_Site_ID[] = [];
}
